import { render, staticRenderFns } from "./status-badge.app.vue?vue&type=template&id=ed4162ec&"
import script from "./status-badge.app.vue?vue&type=script&lang=js&"
export * from "./status-badge.app.vue?vue&type=script&lang=js&"
import style0 from "./status-badge.app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports